import styled from "styled-components"

export default function OrderItemBlock({ children }) {
  return <Block>{children}</Block>
}

const Block = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: calc(100vw * (23 / 375));
`
